import EventManager from "../eventManager.js";

export default class ModeShippingWizard extends EventManager {

    constructor ($container, options) {

        super();

        this.settings = $.extend({}, {
        }, options);

        this.$container = $container;
        this.currentAddress = null;
    }

    updateAddress (address) {
        this.currentAddress = address;
    }

    remove() {
        this.$container.empty();
    }

    update(modeDetails, options) {
    }

    resetSelection() {
        console.log('resetSelection');
    }

    invalidate() {
    }

}
